<script setup lang="ts">
import { ref } from "vue";
import { onMounted, onUnmounted } from "vue";

// 导入图片资源

import follow_ico01b from "./../../../assets/imgs/fm_ico01b.png";

import follow_ico02b from "./../../../assets/imgs/fm_ico02b.png";

import follow_ico03b from "./../../../assets/imgs/fm_ico03b.png";
import email_icon from "./../../../assets/imgs/email.png";
import whatsapp_icon from "./../../../assets/imgs/whatsapp.png";
import facebook_white from "./../../../assets/imgs/facebook_white.png";
import ins_white from "./../../../assets/imgs/ins_white.png";
import youtube_white from "./../../../assets/imgs/youtube_white.png";
import email_white from "./../../../assets/imgs/email_white.png";
import whatsapp_white from "./../../../assets/imgs/whatsapp_white.png";
// 修改 interface 定义
interface NavItem {
  normalImg: string;
  hoverImg?: string;
  hover: boolean;
  link?: string;
  hoverText?: string;
  onClick?: (e: Event) => void;
}

// 修改 handleWhatsAppClick 函数
const handleWhatsAppClick = () => {
  const phoneNumber = "021-6358 1508";
  window.open(`https://wa.me/${phoneNumber.replace(/[^0-9+]/g, "")}`, "_blank");
};

// 修改 handleEmailClick 函数
const handleEmailClick = (e: Event) => {
  window.open("mailto:zhangzhengyi@gylianhe.com", "_blank");
};

const navItems = ref<NavItem[]>([
  {
    normalImg: facebook_white,
    hoverImg: follow_ico01b,
    hover: false,
    link: "https://www.facebook.com/profile.php?id=61558820642464&is_tour_completed",
  },
  {
    normalImg: ins_white,
    hoverImg: follow_ico02b,
    hover: false,
    link: "https://www.instagram.com/tantivyvikadpa",
  },
  {
    normalImg: youtube_white,
    hoverImg: follow_ico03b,
    hover: false,
    link: "https://www.youtube.com/channel/UCTh-j33XNnuY-LYv4RBfXvg",
  },
  {
    normalImg: email_white,
    hoverImg: email_icon,
    hover: false, // 添加 hover 属性
    hoverText: "zhangzhengyi@gylianhe.com",
    onClick: handleEmailClick,
  },
  {
    normalImg: whatsapp_white,
    hoverImg: whatsapp_icon,
    hover: false, // 添加 hover 属性
    hoverText: "021-6358 1508",
    onClick: handleWhatsAppClick,
  },
]);

const handleScrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
// 变量用于存储滚动距离
const scrollDistance = ref(0);

// 滚动事件中更新滚动距离
const updateScrollDistance = () => {
  scrollDistance.value = window.scrollY;
};

// 监听滚动事件
onMounted(() => {
  window.addEventListener("scroll", updateScrollDistance);
});

// 组件卸载时移除滚动事件监听器
onUnmounted(() => {
  window.removeEventListener("scroll", updateScrollDistance);
});
</script>

<template>
  <div class="navbar" :class="{ hidden: scrollDistance < 200 }">
    <ul>
      <li
        class="li_t"
        v-for="(item, index) in navItems"
        :key="index"
        @mouseenter="item.hover = true"
        @mouseleave="item.hover = false"
        @click="item.onClick && item.onClick($event)"
      >
        <a
          :href="item.link"
          v-if="item.link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="item.hover ? item.hoverImg : item.normalImg"
            alt="Navigation Image"
          />
        </a>
        <div v-else class="nav-item">
          <img
            :src="item.hover ? item.hoverImg : item.normalImg"
            alt="Navigation Image"
          />
          <div v-if="item.hoverText && item.hover" class="hover-text">
            {{ item.hoverText }}
          </div>
        </div>
      </li>
      <li class="top" @click="handleScrollToTop">TOP</li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  text-align: center;
  z-index: 999999;
  top: 65%;
  right: 3%;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-50%);
}

ul {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 50px;
  border-radius: 15px;
  background-color: #a1a1a1;
  color: #fff;
  margin-bottom: 20px;
  padding: 20px 0;
}

.li_t {
  cursor: pointer;
  margin-bottom: 15px;
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:last-child {
    margin-bottom: 0;
  }
}

.nav-item,
li a {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

img {
  width: 80%;
  height: 80%;
  object-fit: contain;
}

.hover-text {
  position: absolute;
  right: 130%;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  padding: 10px 15px;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  color: #004080;
  font-size: 14px;
  white-space: nowrap;
  z-index: 1000;
  height: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;

  &:after {
    content: "";
    position: absolute;
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
    border-left: 8px solid #fff;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
  }
}

.top {
  position: absolute;
  left: 0;
  top: 100%;
  font-size: 20px;
  line-height: 50px;
  width: 50px;
  height: 50px;
  background-color: #a1a1a1;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    color: #004080;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }
}

.hidden {
  display: none;
}
</style>
